<template>
  <BitsemsHeaderAndFooter>
    <br />
    <br />

    <v-row align="center" justify="center" class="my-10 mx-10">
      <v-col cols="12" sm="5" md="5" xs="5" class="rounded-corners">
        <v-card class="elevation-12 rounded-corners">
          <v-toolbar dark flat>
            <v-toolbar-title>Login form</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Login"
                name="login"
                prepend-icon="person"
                type="text"
                v-model="email"
              />
              <small
                class="ml-8 red--text"
                v-if="snackbar"
                style="font-size:15px"
              >
                Access Denied!
                {{ loginMsg }}
              </small>

              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                v-model="password"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              x-small
              :color="getThemeColor"
              dark
              @click.prevent="$router.push('/bitsems-register')"
              >Create Account</v-btn
            >
            <v-spacer />
            <v-btn dark @click.prevent="login()" rounded>Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </BitsemsHeaderAndFooter>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import BitsemsHeaderAndFooter from "@/components/Bitsems/BitsemsHeaderAndFooter.vue";
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["getThemeColor"]),
  components: {
    BitsemsHeaderAndFooter,
  },
  data() {
    return {
      siteName: "BITSEMS",
      email: "",
      password: "",
      snackbar: false,
      loginMsg: "",
    };
  },

  methods: {
    async login() {
      const loggegIn = await helpersJs.login(this.email, this.password);
      if (loggegIn) {
        this.$toast.success("Login Successful, Welcome!", { duration: 4000 });
        this.$router.push({ name: "switchboard" });
      } else {
        this.$toast.error("Email or Password Incorrect!", { duration: 4000 });
      }
    }, //end of login method
  },
};
</script>
